import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Card,
  CardContent
} from '@mui/material';
import {
    FaUserTie,
  FaBuilding,
  FaUserCog,
  FaBrain,
  FaNetworkWired,
  FaDatabase,
  FaRocket,
  FaChartLine,
  FaLock
} from 'react-icons/fa';
import Header from '../header/header';
import Footer from '../commun/Footer';

import './Home.css';

const Home = () => (
  <Box className="home">
    <Header />

          {/* Hero Section */}
              <Box className="hero-image-wrapper">
                <picture>
                  <source media="(max-width: 768px)" srcSet="/images/home/hero-mobile.webp" />
                  <source media="(max-width: 1280px)" srcSet="/images/home/hero-tablet.webp" />
                  <img
                    src="/images/home/hero-desktop.webp"
                    alt="Bannière Cooptaleo"
                    className="hero-img"
                  />
                </picture>
                <Box className="hero-overlay">
                  <Container maxWidth="lg">
                    <Box className="hero-content">
                      <Typography variant="h3" className="hero-title">
                        Le futur du recrutement IT commence ici
                      </Typography>
                      <Typography variant="h6" className="hero-subtitle">
                        Cooptaleo connecte entreprises et recruteurs indépendants grâce à une IA experte...
                      </Typography>
                      <Button variant="contained" className="hero-button hero-inscription" href="signup" color="primary">
                        Inscription gratuite
                      </Button>
                      <Button variant="outlined" className="hero-button hero-services" href="/services" color="primary">
                        Nos services
                      </Button>
                    </Box>
                  </Container>
                </Box>
              </Box>

    {/* Recrutement Benefits */}
      <Box className="recruitment-benefits-section">
        <Container>
          <Typography variant="h4" align="center" className="recruitment-title titles" >
          Une nouvelle façon de recruter 
            {/* <span className="highlight-alt"> savoir-faire de milliers de cabinets de recrutement</span> */}
          </Typography>
          <Box className="section-spacing-home" />
          <Grid container spacing={4} justifyContent="center">
          {[
              {
                icon: <FaBrain className="benefit-icon" />,
                title: 'Matching intelligent par IA',
                desc: 'Identifiez les meilleurs profils grâce à notre technologie d’intelligence artificielle.',
              },
              {
                icon: <FaNetworkWired className="benefit-icon" />,
                title: 'Réseau de recruteurs qualifiés',
                desc: 'Bénéficiez d’un réseau de professionnels pour des recrutements ciblés.',
              },
              {
                icon: <FaDatabase className="benefit-icon" />,
                title: 'Base de CV structurée et vivante',
                desc: 'Accédez à une base de données constamment mise à jour.',
              },
              {
                icon: <FaRocket className="benefit-icon" />,
                title: 'Recrutements accélérés',
                desc: 'Réduisez vos délais de recrutement avec notre solution efficace.',
              },
              {
                icon: <FaChartLine className="benefit-icon" />,
                title: 'Pilotage clair et transparent',
                desc: 'Suivez en temps réel l’avancée de vos recrutements.',
              },
              {
                icon: <FaLock className="benefit-icon" />,
                title: 'Sécurité et conformité',
                desc: 'Assurez la protection des données et le respect des réglementations.',
              },
            ].map((item, index) => (
              <Grid item xs={12} md={2} key={index}>
                <Box className="benefit-box">
                  {item.icon}
                  <Box>
                    <Typography variant="subtitle1" className="benefit-title">{item.title}</Typography>
                    {/* <Typography variant="body2" className="benefit-desc">{item.desc}</Typography> */}
                    {/* <Typography variant="body2" className="benefit-link">En savoir plus &gt;</Typography> */}
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

    {/* Étapes */}
     <Box id="explore-services" className="services-by-profile-section-home">
  <Container>
    <Typography variant="h4" align="center" gutterBottom className="section-main-home titles">
      Entreprises, Recruteurs et Experts IT
    </Typography>
            <Typography variant="body1" align="center" className="why-subtitle">
        Une plateforme pensée pour chaque partie prenante
        </Typography>
    <Box className="services-cards-flex-container">

      {/* Service pour les Entreprises */}
      <Card className="service-card">
        <Box className="service-card-image-container">
          <Box className="service-card-icon-overlay">
            <FaBuilding className="service-card-main-icon" />
          </Box>
        </Box>
        <CardContent>
          <Typography variant="h6" align="center" gutterBottom className="service-card-title">
           <strong> Entreprises </strong>
          </Typography>
          <Typography variant="body2" align="center" className="service-card-description">
            Déposez vos besoins IT, choisissez les recruteurs qui vous accompagnent, et suivez vos recrutements en toute autonomie.
          </Typography>
          <Box mt={2} textAlign="center">
            <Button variant="outlined" className="service-card-button" href="signup/entreprise">
              Inscrivez-vous
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Service pour les Recruteurs */}
      <Card className="service-card">
        <Box className="service-card-image-container">
          <Box className="service-card-icon-overlay">
            <FaUserTie className="service-card-main-icon" />
          </Box>
        </Box>
        <CardContent>
          <Typography variant="h6" align="center" gutterBottom className="service-card-title">
            <strong>Recruteurs indépendants</strong>
          </Typography>
          <Typography variant="body2" align="center" className="service-card-description">
            Accédez à des besoins qualifiés, proposez des candidats, et soyez rémunérés selon vos performances.
          </Typography>
          <Box mt={2} textAlign="center">
            <Button variant="outlined" className="service-card-button" href="signup/recruteur">
              Rejoignez le réseau
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Service pour les Talents */}
      <Card className="service-card">
        <Box className="service-card-image-container">
          <Box className="service-card-icon-overlay">
            <FaUserCog className="service-card-main-icon" />
          </Box>
        </Box>
        <CardContent>
          <Typography variant="h6" align="center" gutterBottom className="service-card-title">
            <strong>Experts IT</strong>
          </Typography>
          <Typography variant="body2" align="center" className="service-card-description">
          Déposez votre CV et rejoignez notre vivier de talents qualifiés, accessible aux recruteurs sur la plateforme.         </Typography>
          <Box mt={2} textAlign="center">
            <Button variant="outlined" className="service-card-button" href="signup/candidat">
              Déposez votre CV
            </Button>
          </Box>
        </CardContent>
      </Card>

    </Box>
  </Container>
</Box>



    {/* Pourquoi choisir Cooptaleo ? */}
    <Box className="why-section" >
      <Container>
        <Typography variant="h4" align="center" gutterBottom className='titles'>
          Comment ça fonctionne ?
        </Typography>
        <Typography variant="body1" align="center" className="why-subtitle">
        4 étapes pour transformer vos recrutements.
        </Typography>
        <Grid container spacing={2} justifyContent="center">
        {[
          {
            title: 'Inscription',
            desc: 'Créez gratuitement votre compte entreprise ou recruteur en quelques clics.',
            img: 'https://img.icons8.com/color/96/add-user-male.png',
          },
          {
            title: 'Publication',
            desc: 'Déposez un besoin ou positionnez-vous sur une mission selon votre rôle.',
            img: 'https://img.icons8.com/color/96/megaphone.png',
          },
          {
            title: 'Matching',
            desc: 'L’IA analyse les profils, les missions, et les propositions pour garantir un alignement optimal.',
            img: 'https://img.icons8.com/color/96/artificial-intelligence.png',
          },
          {
            title: 'Recrutement facilité',
            desc: 'Suivez le cycle de vie des candidatures et finalisez vos recrutements en toute simplicité.',
            img: 'https://img.icons8.com/color/96/task-completed.png',
          },
            ].map((item, index) => (
              <Grid item className="why-grid-item" key={index}>
                <Box className="why-card-clean">
                  <Box className="why-img-container">
                    <img src={item.img} alt={item.title} className="why-img" />
                  </Box>
                  <Typography variant="subtitle1" className="why-title">{item.title}</Typography>
                  <Typography variant="body2" className="why-desc">{item.desc}</Typography>
                </Box>
              </Grid>
            ))}
          <Grid item xs={12} style={{ textAlign: 'center', marginTop: '24px' }}>
            <Button variant="contained" color="primary" size="large" href="a-propos">
              Nos services
            </Button>
          </Grid>
          </Grid>


      </Container>
    </Box>

    {/* Étapes */}
    <Box className="steps-section">
      <Container>
          <Typography variant="h4" align="center" gutterBottom className='titles'>
            L’IA au coeur de la plateforme
          </Typography>
          <Typography variant="body1" align="center" gutterBottom>
            L’intelligence artificielle au service de vos recrutements.
           </Typography>
          <Typography variant="body1" align="center" >
          Chez Cooptaleo, l’IA n’est pas un gadget : elle est au cœur de l’expérience utilisateur, pour une prise de décision plus rapide, plus fiable et plus juste. 
          </Typography>
        <Box className="section-spacing" />
        <Grid container spacing={2} justifyContent="center">
          {[
            {
              title: 'Parsing automatique',
              desc: 'Extraction des données essentielles des CVs et structuration des profils.',
              img: 'https://img.icons8.com/color/96/resume.png',
            },
            {
              title: 'Matching IA avancé',
              desc: 'Puissant algorithme de correspondance entre les besoins clients et les profils proposés.',
              img: 'https://img.icons8.com/fluency/96/artificial-intelligence.png',
            },
            {
              title: 'Détection des doublons',
              desc: 'Identification intelligente des profils similaires grâce aux informations personnelles.',
              img: 'https://img.icons8.com/fluency/96/user-group-man-man.png',
            },
            {
              title: 'Optimisation continue',
              desc: 'Analyse des candidatures et retours clients pour améliorer la pertinence des propositions.',
              img: 'https://img.icons8.com/color/96/data-configuration.png',
            },
          ]
          .map((item, index) => (
            <Grid item className="why-grid-item" key={index}>
              <Box className="why-card-clean">
                <Box className="why-img-container">
                  <img src={item.img} alt={item.title} className="why-img" />
                </Box>
                <Typography variant="subtitle1" className="why-title">{item.title}</Typography>
                <Typography variant="body2" className="why-desc">{item.desc}</Typography>
              </Box>
            </Grid>
          ))}

          <Grid item xs={12} style={{ textAlign: 'center', marginTop: '24px' }}>
            <Button variant="contained" color="primary" size="large" href="a-propos">
              A propos
            </Button>
          </Grid>
        </Grid>

      </Container>
    </Box>


    {/* CTA */}
    <Box className="why-section">
      <Container maxWidth="md" style={{ textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Prêt à transformer vos recrutements ?
        </Typography>
        <Typography variant="body1" className="cta-subtitle">
          Découvrez comment Cooptaleo peut vous aider à recruter mieux, plus vite, et plus simplement.
        </Typography>
        <Box mt={3}>
          <Button variant="contained" color="primary" size="large" href= "signup">
            Créer un compte gratuitement
          </Button>
        </Box>
      </Container>
    </Box>

    <Footer />
  </Box>
);

export default Home;
